module.exports = __webpack_public_path__ + "static/img/アセット 35@2x.79f0ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 35@2x.png
// module id = IJPf
// module chunks = 1